<div>
  <!-- <app-document-upload /> -->
  <app-reactive-file-input
    #documentInput
    [labelText]="labelText"
    [sampleImageUrl]="sampleImageUrl"
    [formControl]="fileControl"
    [documentURL]="documentURL"
    [errors]="errors"
    [validationMessage]="validationMessage"
    [fromTh]="fromTh"
    [acceptedFileTypes]="[
      'image/png',
      'image/jpeg',
      'image/jpg',
      'application/pdf'
    ]"
  ></app-reactive-file-input>
</div>
